<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="modal-signup modal-content">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px">

        Add  Abnormality

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px">
        <form class="form" (ngSubmit)="onSubmit()"  novalidate="" #f="ngForm">
          <div class="modal-body padding-top-0px">
            <div class="row margin-left-auto">
              <div class="col-md-12 padding-l-0px">

                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right">
                        <label for="diaplayName"><span>*</span>Abnormality</label>
                      </div>
                      <div class="col-md-7">
                        <!--<CodeTypeValue CodeType="IVFMR"></CodeTypeValue>-->
                        <CodeTypeValue CodeType="IVFMR" id="CurrentSaveOocyteMorphologyInfoRequest.Morphology"
                                       [(ngModel)]="CurrentSaveOocyteMorphologyInfoRequest.Morphology" SelectedValue=""
                                       name="CurrentSaveOocyteMorphologyInfoRequest.Morphology" required #Abnormality="ngModel">

                        </CodeTypeValue>

                      </div>
                    </div>


                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                    <div class="row">
                      <div class="col-md-3 text-align-right ">
                        <label for="diaplayName"><span>*</span>Count</label>
                      </div>
                      <div class="col-md-2 padding-right-0px">

                        <!--<input type="number" class="form-control" id="CurrentSaveOocyteMaturityInfoRequest.OocyteCount"
         [(ngModel)]="CurrentSaveOocyteMaturityInfoRequest.OocyteCount"
         name="CurrentSaveOocyteMaturityInfoRequest.OccCount"
         placeholder="Count" maxlength="20" minlength="1" #Ntimes="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$">
  <small class="form-text text-danger"
         *ngIf="(!Ntimes.valid && (Ntimes.dirty || Ntimes.touched) && Ntimes.errors.required)">(Field cannot be left blank)</small>
  <small class="form-text text-danger"
         *ngIf="(!Ntimes.valid && Ntimes.errors.pattern)">(special characters are not allowed)</small>-->
                        <CodeTypeValue CodeType="1to20" id="CurrentSaveOocyteMorphologyInfoRequest.OocyteCount"
                                       [(ngModel)]="CurrentSaveOocyteMorphologyInfoRequest.OocyteCount" SelectedValue=""
                                       name="CurrentSaveOocyteMorphologyInfoRequest.OocyteCount" required #Count="ngModel">

                        </CodeTypeValue>
                      </div>
                    </div>


                  </div>
                </div>
                
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Close</button>
            <button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-right-auto" [disabled]="Abnormality.errors?.required || Count.errors?.required ">Save</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

